import { toPng } from "html-to-image";
import { toast } from "sonner";

export async function nodeToPng(node) {
  // Ensure self-hosted fonts are fully loaded so the raster never uses a fallback face
  if (document.fonts && document.fonts.ready) {
    try {
      await document.fonts.ready;
    } catch {
      /* noop */
    }
  }
  return toPng(node, {
    cacheBust: true,
    pixelRatio: 2,
    skipFonts: false,
  });
}

function dataUrlToFile(dataUrl, filename) {
  const [meta, b64] = dataUrl.split(",");
  const mime = meta.match(/:(.*?);/)[1];
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new File([arr], filename, { type: mime });
}

export async function shareOrDownload(dataUrl, filename, shareText) {
  try {
    const file = dataUrlToFile(dataUrl, filename);
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: "What's in the Fridge",
        text: shareText || "",
      });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return;
  }
  // Fallback: download
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  toast("Saved the card to your device.");
}
